const TipoAportacionODepositoOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: 'Aportaciones voluntarias o complementarias efectuadas en términos del artículo 151, fracción V de la LISR. (a)',
    value: 'a'
  },
  {
    label: 'Depósitos a cuentas especiales, prima de seguros o adquisición de acciones, efectuadas en términos al artículo 185 de la LISR (b)',
    value: 'b'
  },
  {
    label: 'Aportaciones adicionales efectuadas en términos del artículo 258 (c)',
    value: 'c'
  }
];

export default TipoAportacionODepositoOptions;
